import React from "react";
import { useIntl } from "react-intl";
import WisepopsLogoPath from "src/integrations/logos/WisepopsLogo.svg";

export const WisepopsLogo = () => {
  const intl = useIntl();
  return (
    <img
      src={WisepopsLogoPath}
      alt={intl.formatMessage({ id: "integrations.wisepops" })}
    />
  );
};
